<template>        
  <div class="submissions-documents">
    <div class="u-container">
      <p class="submissions-document__num-results">{{ totalResults }} result<span v-if="totalResults > 1">s</span>{{ calcResultsShowing() }}</p>
      <submission-cards></submission-cards>
    </div>
  </div>
</template>
  
<script>
  import { mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import SubmissionCards from "./SubmissionCards.vue";
  
  export default {
    name: "SubmissionsDocuments",
    components: {
      'submission-cards': SubmissionCards,
    },
    computed: {
      ...mapFields([
        "viewContent.submissions",
        "submissions.totalResults",
        "submissions.currentPage",
        "submissions.perPage",
      ]),
      ...mapGetters([
        "getFilteredSubmissions",
      ]),
    },
    methods: {
      calcResultsShowing() {
        // calculate the number range of results showing
        // if we only have 1 page, return blank
        if (this.totalResults < 16) {
          return "";
        }
        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.totalResults);
        return `, showing ${start} to ${end}`;
      },
    }
  };
</script>  